import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './input.scss';

const Input = ({
    value = '',
    type,
    name,
    placeholder,
    onChange,
    label,
    hasError = false,
    validationType,
    maxCharacters
}) => {
    const [inputValue, setInputValue] = useState(value);
    const classNames = hasError ? 'form-input error' : 'form-input';

    useEffect(() => {
        setInputValue(value)
    }, [value]);

    const handleChange = ({ target: { value, name } }) => {
        setInputValue(value);
        onChange(name, value, validationType, maxCharacters);
    };

    return (
        <input
            className={classNames}
            name={name}
            placeholder={placeholder || type}
            value={inputValue}
            type={type}
            onChange={handleChange}
            aria-label={label}
            maxLength={maxCharacters}
        />
    );
};

Input.propTypes = {
    value: PropTypes.string,
    type: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    hasError: PropTypes.bool,
    validationType: PropTypes.string,
    maxCharacters: PropTypes.number,
};

export default Input;
